import React, {  useState } from "react";
import styles from "./UsersTable.module.scss";
import { useQuery } from "@apollo/client";
import { ORGANISATIONS, USERS_OF_ORGANISATION } from '../../apollo/queries';
import {UserTableRow } from './types';
import { Field, Formik } from 'formik';
import { Input } from '../common/Input';
import DataTable from 'react-data-table-component';
import { customStyles } from '../DataTable/customStyles';
import columns from './columnDefs';
import { ModalOverlay } from '../ModalOverlay';
import { DeactivateUser } from '../DeactivateUser';


interface userTableInput {
    organisationId: Number,
    canDeactivate?: boolean
}

const initialFormValues = {
    search: "",
};

// @ts-ignore
const mapData = (data) => {
    console.log(data)
    // @ts-ignore
    return data.usersByOrganisation.map((row) => {
        return {
            id: row.id,
            organisationType: row.organisation.organisationType,
            companyName: row.organisation.name,
            function: row.function,
            name: row.name,
            emailAddress: row.emailAddress,
            locale: row.locale,
            phoneNumber: row.phoneNumber,

        }
    })
}

export const UsersTable = ({ organisationId, canDeactivate = true }: userTableInput) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
    const [showDeactivateUserModal, setShowDeactivateUserModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);


  useQuery(USERS_OF_ORGANISATION, {
        variables: {
            usersByOrganisationOrganisationId: organisationId
        },
        onCompleted: (someData) => {
          setLoading(false)
          setData(mapData(someData))
        },
        fetchPolicy: "no-cache"
  });

  const searchAction = (search: string) => {
      search = search.toLowerCase()

      const result = data.filter((row: UserTableRow) => {
        return (
            row.organisationType?.toLowerCase().includes(search)
            || row.companyName?.toLowerCase().includes(search)
            || row.function?.toLowerCase().includes(search)
            || row.name?.toLowerCase().includes(search)
            || row.emailAddress?.toLowerCase().includes(search)
            || row.locale?.toLowerCase().includes(search)
            || row.phoneNumber?.toLowerCase().includes(search)
        )
      })

      setData(result)
  }

  return (
      <div className={styles.wrapper}>
          <Formik
              initialValues={initialFormValues}
              onSubmit={(
                  values: {
                      search: string
                  },
              ) => {
                  const { search } = values;
                  searchAction(search);
              }}
          >
              {({ values, handleChange, handleSubmit }) => (
                  <form className={styles.formContainer} onSubmit={handleSubmit}>
                      <div className={styles.searchContainer}>
                          <Field
                              name="search"
                              as={Input}
                              type="text"
                              placeholder="Filter on..."
                              onChange={handleChange}
                              value={values.search}
                              // autoFocus
                          />
                          <span title="Reset" onClick={() => {
                              values.search = '';
                          }} className={styles.clearSearch}>X</span>
                          <button type="submit">
                              <img
                                  src="/assets/search.svg"
                                  width="20"
                                  height="20"
                                  alt="search"
                              />
                          </button>
                      </div>
                  </form>
              )}
          </Formik>
          <span className={styles.recordsSpan}>No. records: {data.length}</span>
          <div className={styles.main}>
              <DataTable
                  // @ts-ignore
                  customStyles={customStyles}
                  // @ts-ignore
                  columns={columns(
                      (row: any) => {
                          setSelectedUserId(row.id)
                          setShowDeactivateUserModal(true)
                      },
                      canDeactivate
                  )}
                  data={data}
                  defaultSortFieldId="createdAt"
                  defaultSortAsc={false}
                  highlightOnHover
                  progressPending={loading}
                  noDataComponent={<div style={{ padding: '40px' }}>No records found</div>}
                  // rowKey="id"
                  fixedHeader={true}
                  fixedHeaderScrollHeight={'800px'}
              />
          </div>
          <ModalOverlay show={showDeactivateUserModal}>
              <DeactivateUser id={selectedUserId ? selectedUserId : -1} onToggle={() => {
                  setShowDeactivateUserModal(!showDeactivateUserModal)
              }}></DeactivateUser>
          </ModalOverlay>
      </div>
  )
};
